import React from 'react';

import { Container, Wrapper, Content } from './styles';

const PrivacyPolicy: React.FC = () => {
  return (
    <Container>
      <Wrapper>
        <header>
          <div>
            <h1>Políticas de privacidade</h1>
          </div>
        </header>
        <Content>
          <div className="privacy-policy">
            <h3>Termos e condições gerais de uso e de compra e venda</h3>
            <a
              href="https://retaguarda.atacdelivery.com/api/files/TERMOS_E_CONDICOES_GERAIS_DE_USO_E_DE_COMPRA_E_VENDA_R.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Acessar termos e condições
            </a>
          </div>
          <div className="privacy-policy">
            <h3>Termo de consentimento</h3>
            <a
              href="https://retaguarda.atacdelivery.com/api/files/TERMO_DE_CONSENTIMENTO.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Acessar termo de consentimento
            </a>
          </div>
        </Content>
      </Wrapper>
    </Container>
  );
};

export default PrivacyPolicy;
